import { API_ENDPOINTS } from '../../constants/apiEndpoints';
import { ENVIRONMENT_CONFIG } from '../../constants/environmentConfig';
import fetcher from '../../helpers/fetcher';

export const getCitizenPriceCount = async () => {
  try {
    const data = await fetcher.get(
      API_ENDPOINTS.DASHBOARD.GET_PUBLIC_CITIZEN_BASIC_STATS,
      {},
      {},
      ENVIRONMENT_CONFIG.ANALYSIS_SERVICE
    );

    return data.data;
  } catch (error) {}
};
